





















































import Component from 'vue-class-component';
import PluginComponent from '../PluginComponent';
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { EVENTS } from '@/services/EventBus';
import chroma from 'chroma-js';
import Indicator from '@/models/map-context/Indicator';
import IStat from '@/models/map-context/IStat';
import StyleRule from '@/models/map-context/style/StyleRule';

Chart.plugins.register(ChartDataLabels);

@Component({
  props: {},
  components: {},
})
export default class IndicatorPlugin extends PluginComponent {
  static ID = 'IndicatorPlugin';

  isLoading = false;

  filteredData: Indicator[] = [];

  chartInstances: Chart[] = [];

  selectedFeature = false;
  currentFeature: any = null;
  showFilters = true;

  currentChartHover: any = null;

  featureTitle = 'objet selectionné';

  created() {
    this.getEventBus().$on(EVENTS.MAP_CURRENT_BBOX_CHANGE, this.fetchDatas);
  }

  update() {
    this.fetchDatas();
  }

  resetSearch() {}

  mounted() {
    this.getEventBus().$on(EVENTS.SELECT_FEATURE, this.onFeatureSelected);
    this.getEventBus().$on(EVENTS.SELECT_NO_FEATURE, this.cleanSelection);

    if (!this.selectedFeature) {
      this.filteredData = [];
    }

    const selectedFeatures = this.getMapService().selectionService.selectedFeature;
    if (selectedFeatures !== undefined) {
      this.onFeatureSelected(selectedFeatures);
    }
  }

  getDistinctValues(list: any): any[] {
    const distinct = list.filter((item: any, i: any, ar: any) => ar.indexOf(item) === i); // to get distinct values
    return distinct;
  }

  closePanel() {
    this.selectedFeature = false;
    this.getMapService().selectionService.cleanSelection();
    this.getMapService().selectionService.selectFeatures([], false, false); //selectedFeature=null;
  }

  async fetchDatas() {
    this.filteredData = [];

    let layerWithIndictors = this.getMapService()
      .getOrderedLayerList()
      .filter(function (layer) {
        return layer.indicators.isDefined();
      });
    layerWithIndictors.forEach((layer) => {
      if (layer && layer.isLayerVisible() && layer.inRange(this.getMapService().currentScale)) {
        let indic = layer.indicators.indicators;
        let features = layer
          .getLayerSource()
          .getFeaturesInExtent(this.getMapService().getMapExtent());

        indic.forEach((indicator: Indicator) => {
          indicator.layer=layer;
          indicator.computeStats(features,layer);
          this.filteredData.push(indicator);
        });
      }
    });
    this.renderCharts();
    setTimeout(()=>{
      layerWithIndictors.forEach((layer) => {
            if (layer && layer.isLayerVisible() && layer.inRange(this.getMapService().currentScale)) {
              let featureinCenter = layer
                .getLayerSource()
                .getFeaturesAtCoordinate(this.getOpenLayersMapService().map.getView().getCenter());
            
              if (featureinCenter && featureinCenter.length == 1) {
                featureinCenter[0].layerConfig = layer;
                this.onFeatureSelected(featureinCenter,true);
              }else if(this.currentFeature!=null){
                this.onFeatureSelected([this.currentFeature],false);
              }
            }
      });
    },200);
   
  }

  beforeDestroy() {
    this.chartInstances.forEach((chart) => chart.destroy());
  }
  onFeatureSelected(features: any,centerMapSelection=false) {
    console.log(features);
    this.showFilters = false;
    this.selectedFeature = true;
    if (features.length > 0) {
      this.currentFeature = features[0];

      let selectedlayer = this.currentFeature.layerConfig;
      let indic = selectedlayer.indicators.indicators;
      indic.forEach((indicator: Indicator) => {
        this.featureTitle = this.currentFeature.get(indicator.labelAttribute);
        if (indicator.isGraph() && (centerMapSelection==false||indicator.showCenterObject) ) {
          let chart = indicator.chart;
          this.$nextTick(() => {
            chart.data.labels.push(this.featureTitle);
            chart.data.datasets[0].data.push(
              Number(this.currentFeature.get(indicator.attributeName))
            );
            if(indicator.useColorFromAnalyse){
              chart.data.datasets[0].backgroundColor.push(indicator.layer!.complexStyle.getColorFromAnalyse(Number(this.currentFeature.get(indicator.attributeName)), indicator.attributeName));
            }
            chart.update();
          });
        } else if(indicator.isTextArea() && (centerMapSelection==false||indicator.showCenterObject)){
          indicator.currentSelectContent = indicator.replaceContent(
            indicator.textSelectContent,
            indicator.stats,
            this.currentFeature
          );
        }
      });
    } else {
      this.featureTitle = 'indicateurs';
    }
  }

  cleanSelection() {
    this.selectedFeature = false;
    this.currentFeature=null;
    this.featureTitle = 'indicateurs';
    this.renderCharts();
  }

  renderCharts() {
    this.chartInstances.forEach((chart) => chart.destroy());
    this.chartInstances = [];

    this.$nextTick(() => {
      this.filteredData.forEach((item: Indicator, index) => {
        const graphDiv: any = this.$refs[`graphElement${index}`] as HTMLCanvasElement;
        if (graphDiv && item.isGraph()) {
          graphDiv[0].height = 400;
          let backgroundColor = chroma.scale(item.colorPalette).colors(item.nbColors);
          
          
          if (item.graphType == 'minmaxmean') {


            let stats: IStat = item.stats;

            if(item.useColorFromAnalyse){
              backgroundColor=[stats.min, stats.max, stats.mean].map((val:number)=>{
                return item.layer!.complexStyle.getColorFromAnalyse(val, item.attributeName);
              });
            }
            const chartInstance = new Chart(graphDiv, {
              type: 'bar',
              data: {
                labels: ['min', 'max', 'mean'],
                datasets: [
                  {
                    label: item.label,
                    data: [stats.min, stats.max, stats.mean],
                    backgroundColor: backgroundColor,
                    borderWidth: 1,
                  },
                ],
              },
              options: {
                responsive: true,
                legend: {
                  reverse: true,
                  display: false,
                  position: 'bottom',
                },
                plugins: {
                  legend: {
                    maxHeight: 200,
                  },
                  datalabels: {
                    color: '#fff',
                    textShadowColor: '#000',
                    textShadowBlur: 5,
                    textStrokeWidth: 1,
                    textStrokeColor: '#000',
                    //backgroundColor:'#ffffff',
                    anchor: 'center',
                    align: 'center',
                    font: { weight: 'bold' },
                    formatter: (value: any) => value,
                  },
                },
              },
            });
            item.chart = chartInstance;
            this.chartInstances.push(chartInstance);
          } else {
            //let backgroundColor = ['#244500', '#8ebd3e', '#8ebd00', '#8ebd88', '#8ebddc', '#8ebdcc', '#00bd88'];
            let self=this;
            const chartInstance:any = new Chart(graphDiv, {
              type: 'doughnut',
              data: {
                labels: item.stats.map((x: any) => x.title),
                datasets: [
                  {
                    label: item.label,
                    data: item.stats.map((x: any) => x.count),
                    backgroundColor: backgroundColor,
                    borderWidth: 1,
                  },
                ],
              },
              options: {
                responsive: true,
                legend: {
                  reverse: true,
                  display: false,
                  position: 'bottom',
                },
                onHover: function(evt,item) {
                  console.log("hover evt",evt);
                  
                  if (item.length) {
                    console.log("onHover",item, evt.type);
                    let i:any=item[0];
                    const data = i._chart.config.data.datasets[0].data[i._index];
                    const label = i._chart.config.data.labels[i._index];
                    console.log(item, data, label);
                    self.currentChartHover=i._chart;
                    let filter= i._chart.indicator.attributeName + "='" + label + "'";
                    i._chart.indicator.layer.complexStyle.styleRules.forEach((x:any) => x.active = false);
                    i._chart.indicator.layer.complexStyle.styleRules.find((x:StyleRule) => x.value==filter).active=true;
                    i._chart.indicator.layer.updateStyle();
                    //console.log(">data", item[0]._index, data.datasets[0].data[item[0]._index]);
                  }
                  else if(self.currentChartHover!=null){
                    self.currentChartHover.indicator.layer.complexStyle.styleRules.forEach((x:any) => x.active = true);
                    self.currentChartHover.indicator.layer.updateStyle();
                    self.currentChartHover=null;

                  }
                },
                plugins: {
                  legend: {
                    maxHeight: 200,
                  },
                  datalabels: {
                    color: '#fff',
                    textShadowColor: '#000',
                    textShadowBlur: 5,
                    textStrokeWidth: 1,
                    textStrokeColor: '#000',
                    //backgroundColor:'#ffffff',
                    anchor: 'center',
                    align: 'center',
                    font: { weight: 'bold' },
                    formatter: (value: any) => value,
                  },
                },
              },
            });
            item.chart = chartInstance;
            chartInstance.indicator = item;
            this.chartInstances.push(chartInstance);
          }
        }
      });
    });
  }
}
